module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-h-full noselect"
  }, [_c('div', {
    staticClass: "tw-flex tw-items-center tw-mb-2"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("VALIDEURS D'ABSENCES")]), _vm._v(" "), _c('div', {
    staticClass: "tw-ml-2 tw-text-blue-400 hover:tw-text-blue-500 tw-transition-colors tw-duration-200 tw-cursor-pointer",
    attrs: {
      "title": "Ajouter un valideur"
    },
    on: {
      "click": function($event) {
        _vm.addValidation()
      }
    }
  }, [_c('span', {
    staticClass: "fa-solid fa-xl fa-circle-plus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inp-table"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tbody"
  }, [(!_vm.dataReady) ? _c('div', {
    staticClass: "tw-absolute tw-left-0 tw-right-0 tw-top-0 tw-bottom-0 tw-bg-gray-500/10 tw-z-10"
  }, [_c('loader')], 1) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.listeValideursConges), function(validation) {
    return _c('div', {
      staticClass: "tr"
    }, [_c('div', {
      staticClass: "td cln-nom"
    }, [_vm._v(_vm._s(validation.Utilisateur.Nom) + " " + _vm._s(validation.Utilisateur.Prenom))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-statut tw-text-center"
    }, [(validation.Utilisateur.Origine === _vm.utilisateurOrigineEnum.Salarie) ? _c('span', [_vm._v("Salarié")]) : (validation.Utilisateur.Origine === _vm.utilisateurOrigineEnum.UtilisateurExterne) ? _c('span', [_vm._v("Non salarié")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "td cln-niveau1 tw-text-center"
    }, [_c('span', {
      class: validation.Niveau === _vm.niveauValidationEnum.Niveau_1 ? 'fa-solid fa-lg fa-check tw-text-green-500' : 'fa-light fa-dash tw-text-gray-400'
    })]), _vm._v(" "), _c('div', {
      staticClass: "td cln-niveau2 tw-text-center"
    }, [_c('span', {
      class: validation.Niveau === _vm.niveauValidationEnum.Niveau_2 ? 'fa-solid fa-lg fa-check tw-text-green-500' : 'fa-light fa-dash tw-text-gray-400'
    })]), _vm._v(" "), _c('div', {
      staticClass: "td cln-mail tw-text-center"
    }, [(validation.EnvoiEmail) ? _c('span', [_vm._v("Actif")]) : _c('span', {
      staticClass: "fa-light fa-dash tw-text-gray-400"
    })]), _vm._v(" "), _c('div', {
      staticClass: "td cln-action tw-flex"
    }, [_c('div', {
      staticClass: "tw-border-r tw-border-gray-200 tw-h-full tw-pr-2 tw-flex tw-items-center"
    }, [_c('Button', {
      attrs: {
        "icon": "fa-solid fa-pencil fa-fw",
        "color": "orange",
        "title": "Modifier la validation"
      },
      on: {
        "click": function($event) {
          _vm.modifyAction(validation)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "tw-h-full tw-ml-2 tw-flex tw-items-center"
    }, [_c('Button', {
      attrs: {
        "icon": "fa-solid fa-trash fa-fw",
        "color": "red",
        "title": "Supprimer la validation"
      },
      on: {
        "click": function($event) {
          _vm.deleteAction(validation.Id)
        }
      }
    })], 1)])])
  }), _vm._v(" "), (!_vm.listeValideursConges.length) ? _c('div', {
    staticClass: "empty-area h-100"
  }, [_vm._m(2)]) : _vm._e()], 2)]), _vm._v(" "), _c('modal-validation', {
    ref: "modalValidation",
    attrs: {
      "listeUtilisateurs": _vm.listeUtilisateurs
    },
    on: {
      "refreshListeValideursConges": _vm.refreshListeValideursConges
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thead"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th cln-nom nohover",
    attrs: {
      "title": "Nom"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Nom")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-statut nohover",
    attrs: {
      "title": "Statut"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Statut")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-niveau1 nohover",
    attrs: {
      "title": "Niveau 1"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Niveau 1")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-niveau2 nohover",
    attrs: {
      "title": "Niveau 2"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Niveau 2")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-mail nohover",
    attrs: {
      "title": "Envoi de mail"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Envoi email")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-action nohover",
    attrs: {
      "title": "Actions"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Actions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "section cln-nom"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-statut"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-niveau1"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-niveau2"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-mail"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-action"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('span', {
    staticClass: "fas fa-info-circle fa-3x mb-2"
  }), _vm._v(" "), _c('div', [_vm._v("Aucun valideur")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4443f5f4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ficheSalarie/absences/validationAbsence/validationAbsence.vue.html
// module id = 7qWq
// module chunks = 2